<template>
        <v-dialog
      v-model="dialog" persistent
      width="800"
      aria-labelledby="login-dialog-title"
      >
       <v-card>
        <v-card-title id="login-dialog-title" class="headline">
          Login
          <v-btn class="closebtn" fab small @click="setClose" aria-label="Chiudi"><v-icon dark aria-hidden="true">close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
                <v-form v-model="valid" @keyup.native.enter="login" >
                  <v-text-field
                    label="Login"
                    name="username"
                    v-model="username"
                    prepend-icon="person"
                    type="text"
                    :rules="rules"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="pass"
                    v-model="pass"
                    prepend-icon="lock"
                    type="password"
                    :rules="rules"
                  ></v-text-field>
                </v-form>
        </v-card-text>
        <v-card-actions>
          <v-alert type="error" dismissible v-if="error"  dense>{{error}}</v-alert>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="login">Login</v-btn>
        </v-card-actions>
       </v-card>
      </v-dialog>

</template>

<script>
import Api from '@/services/Api';
export default {
  mounted() {
    
  },
  data() {
    return {
      dialog:true,
      valid:true,
      error:"",
      username:"",
      pass:"",
      rules: [
        value => !!value || 'Required.',
        value => (value || '').length <= 20 || 'Max 20 characters',
      ]

    }
  },
  computed: {
  },
  methods:{
    login() {
      try {
        if (this.valid == true) {
          Api()
          .post("/api/cms/login",{username:this.username,pass:this.pass})
          .then((result) => {
            if(result.data) {
              this.$store.commit("setFeLoggedId",result.data.token);
              this.$emit("close");
            }
          }).catch((error)=> {
            this.error = error.response.data;
            setTimeout(()=>{this.error = ""},6000)

          }) 
        }
      } catch(err) {
        console.log(err);
      }
      
    },
    setClose() {
      this.$emit("close");
    }

  }
}
</script>

<style scoped>
.closebtn {
  position:absolute;
  right:8px;
}
</style>